import salesAnalyticsCountry from '@/components/analytics/salesAnalytics/country/storage';
import salesAnalyticsCountryBrand from '@/components/analytics/salesAnalytics/countryBrand/storage';

export default {
    namespaced: true,
    modules: {
        salesAnalyticsCountry,
        salesAnalyticsCountryBrand,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}